import { AddLabelButton, LabelsPage } from "features/labels/components";
import useAllLabels from "features/labels/datahooks/useAllLabels";
import { NavTabsContentContainer } from "features/layout/components";

import { LEADS_TAB_ITEMS } from "../constants";

const labelType = "workspace";

export default function Labels() {
  const { allLabels } = useAllLabels(labelType);

  return (
    <NavTabsContentContainer
      desktopActionComponent={
        !!allLabels?.length && (
          <AddLabelButton size="sm" labelType={labelType} />
        )
      }
      tabItems={LEADS_TAB_ITEMS}
    >
      <LabelsPage type={labelType} />
    </NavTabsContentContainer>
  );
}
